<template>
    <external-list
            :headlines="[{text: 'Title', width: 5}, {text: 'Block Type', width: 5}]"
            endpoint="/api/v2/marketing-site-blocks"
            :endpoint-filters="{marketing_site_page_id: page.id}"
            :can-destroy="() => true"
            reorder-endpoint="/api/v2/marketing-site-blocks/priorities"
            :get-reorder-payload="data => ({marketing_site_blocks: data})"
            @show="show"
    >
        <template v-slot:default="{ row: block }">
            <td>
                <router-link :to="getUrl(block)">
                    {{ block.attributes.title }}
                </router-link>
            </td>

            <td>
                {{ block.attributes.block_type_name }}
            </td>
        </template>
    </external-list>
</template>

<script>
    import ExternalList from '@/components/Panels/Lists/External'

    export default {
        components: {ExternalList},

        props: {
            portal: {
                required: true
            },

            page: {
                required: true
            },

            blockTypes: {
                required: true
            }
        },

        data() {
            return {
                editing: null
            }
        },

        methods: {
            show(block) {
                this.$router.push(this.getUrl(block))
            },

            getUrl(block) {
                return '/marketing-sites/' + this.portal.id + '/pages/' + this.page.id + '/blocks/' + block.id
            }
        }
    }
</script>

